const formSpree = 'https://formspree.io/xeqllknd';

export default formSpree;